import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ziyuanldpi1",
  "use": "icon-ziyuanldpi1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ziyuanldpi1\"><path d=\"M929.228487 532.990618a73.112568 73.112568 0 0 0-103.819846 0L584.868294 774.262091V73.112568a73.112568 73.112568 0 0 0-146.225136 0v701.149523l-240.540347-241.271473A73.112568 73.112568 0 1 0 94.282965 636.810464l365.562838 365.562838a73.112568 73.112568 0 0 0 103.819846 0l365.562838-365.562838a73.112568 73.112568 0 0 0 0-103.819846z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol